import _ from "lodash";

// Write only the columns that actually changed since load, so a small edit (an
// emoji, a bio) doesn't rewrite the whole row -- and, crucially, so a field left
// at its in-memory default (e.g. after a read timed out on a flaky / VPN
// connection) is NOT written back over the real value in the DB. A null baseline
// means the row isn't known to exist, so write everything to create it. `keep`
// columns are always included (e.g. id/uid to target the row, migrated to flip
// ownership) even when unchanged.
export const changedColumns = (row, baseline, keep = []) =>
  baseline == null
    ? row
    : _.pickBy(row, (v, k) => keep.includes(k) || !_.isEqual(v, baseline[k]));

// Did the diff carry anything beyond the always-kept bookkeeping columns?
export const hasPayload = (row, keep) => _.keys(_.omit(row, keep)).length > 0;
